import {
  HubConnection,
  HubConnectionBuilder,
  IRetryPolicy,
  LogLevel,
  RetryContext,
} from "@microsoft/signalr";

/**
 * Establish and start a SignalR `HubConnection` for the given hub URL.
 *
 * @param url - The hub URL to connect to.
 * @returns A started `HubConnection` instance.
 */
export const connectToHub = async (url: string): Promise<HubConnection> => {
  // Custom retry policy: 0ms, 2s, 10s, 30s delays between reconnect attempts.
  const retryDelays = [0, 2000, 10000, 30000];
  const retryPolicy: IRetryPolicy = {
    nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
      if (retryContext.previousRetryCount >= retryDelays.length) {
        return null;
      }
      return retryDelays[retryContext.previousRetryCount];
    },
  };

  const conn = new HubConnectionBuilder()
    .withUrl(url)
    .configureLogging(LogLevel.Warning)
    .withAutomaticReconnect(retryPolicy)
    .build();
  await conn.start();
  return conn;
};
